import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import autobind from 'autobind-decorator';
import moment from 'moment';

@inject('songsStore')
@observer
class SongRow extends Component {
	@autobind
	onPlayClick () {
		this.props.songsStore.currentSongPlayback = this.props.song;
	}

	render () {
		const { song, songsStore } = this.props;
		const addedDate = moment(new Date(song.dateAdded), 'YYYYMMDD').fromNow();
		const _id = song._id;
		const checkboxID = `title-${_id}`;
		const songIndex = songsStore.getItemIndex(song);

		return (
			<div className="grid-x align-middle song-row">
				<div className="cell shrink">
					<span className="far fa-play-circle" onClick={ this.onPlayClick }></span>
				</div>

				<div className="cell auto">
					<div>{ song.title }</div>
				</div>
			</div>
		);
	}
}

export default SongRow;
